import { render, staticRenderFns } from "./Tickets.vue?vue&type=template&id=dcefe1ae&scoped=true"
import script from "./Tickets.vue?vue&type=script&lang=ts"
export * from "./Tickets.vue?vue&type=script&lang=ts"
import style0 from "./Tickets.vue?vue&type=style&index=0&id=dcefe1ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcefe1ae",
  null
  
)

export default component.exports